/* eslint-disable @typescript-eslint/no-explicit-any */
import { IOptions, IResponse } from './types'

export const processQuery = (queryObject: any): string => {
  const paramKeys = Object.keys(queryObject)

  return paramKeys.reduce((query: string, queryFragment: string, index: number) => {
    const paramChain = index === paramKeys.length - 1 ? '' : '&'
    query += `${queryFragment}=${JSON.stringify(queryObject[queryFragment])}${paramChain}`

    return query
  }, '')
}

export const setPageSize = (query: any): any => {
  const { page_size = 100 } = query
  return { ...query, page_size }
}

export const getOptions = (): IOptions => ({
  connectApiUrl: process.env.CONNECT_API_URL,
  options: {
    method: 'GET',
    headers: {
      'x-capi-key': process.env.CONNECT_API_KEY,
    },
  },
})

export const getFullPath = (connectApiUrl, path, initialQuery, pageNumber?: number): string => {
  let query = initialQuery
  if (pageNumber) {
    query = {
      ...query,
      page_number: pageNumber,
    }
  }
  return `${connectApiUrl}${path}?${processQuery(query)}`
}

export const isValidResponse = (response: IResponse): boolean => {
  return Boolean(response.status < 500)
}
